import React from "react"
import Layout from "../../../components/shared/layout"
import SEO from "../../../components/shared/seo"
import Hero from "./hero"
import Overview from "./overview"
import CommunityStandards from "./standard"
import Workflow from "./workflow"
import Exporter from "./exporter"
import BlogBanner from "./blog-banner"
import ContactForm from "../../../components/shared/contact"
import Footer from "../../../components/shared/footer"

export default function IMDFPage({ location }) {
  return (
    <Layout location={location} contactLightbox>
      <SEO
        title="Indoor Mapping Data Format (IMDF)"
        description="University and college campuses are often large, confusing, and have both indoor and outdoor components. A digital interactive map of your campus can make students, parents, and faculty members feel at ease. With a powerful search engine and maps that function across any device, it can be stress-free to find an upcoming class or nearby food vendor. "
      />
      <Hero title="Indoor Mapping Data Format (IMDF)" />
      <Overview />
      <CommunityStandards />
      <Workflow />
      <Exporter />
      <BlogBanner />
      <ContactForm />

      <Footer />
    </Layout>
  )
}
